import Parse from 'parse';

class CollectionItem extends Parse.Object {
  constructor(attributes, options) {
    super('PlaylistItem', attributes, options);
  }
}

export default CollectionItem;
